import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuthStore } from "../../store/useAuthStore";
import { toast } from "react-toastify";
import { useEffect } from "react";

export default function AdminRoute() {
  const {
    accessToken,
    type,
    status,
    dataProfile,
    isVerified,
  } = useAuthStore();

  const location = useLocation();
  const path = location.pathname;
  const lang = path.startsWith("/id") ? "id" : "en";

  const jobPostPaths = [
    `/${lang}/admin/job-post`,
    `/${lang}/admin/job-post/create`,
    `/${lang}/admin/job-post/edit`,
    `/${lang}/admin/job-post/candidate`,
  ];

  // 🔔 TOAST
  useEffect(() => {
    if (!accessToken || type !== "company" || !status) return;

    if (!dataProfile && path !== `/${lang}/admin/user-profile`) {
      toast.error(
        lang === "id"
          ? "Lengkapi data profil terlebih dahulu"
          : "Please complete your profile first",
        { toastId: "need-profile" }
      );
    }

    if (
      dataProfile &&
      !isVerified &&
      jobPostPaths.some((p) => path.startsWith(p))
    ) {
      toast.error(
        lang === "id"
          ? "Lengkapi dan verifikasi profil perusahaan terlebih dahulu"
          : "Please complete and verify your company profile first",
        { toastId: "need-verification" }
      );
    }
  }, [accessToken, type, status, dataProfile, isVerified, path, lang]);

  if (!accessToken || type !== "company" || !status) {
    return <Navigate to={`/${lang}/login`} replace />;
  }

  if (!dataProfile && path !== `/${lang}/admin/user-profile`) {
    return <Navigate to={`/${lang}/admin/user-profile`} replace />;
  }

  if (
    dataProfile &&
    !isVerified &&
    jobPostPaths.some((p) => path.startsWith(p))
  ) {
    return <Navigate to={`/${lang}/admin/company-profile`} replace />;
  }

  // ✅ AMAN
  return <Outlet />;
}
